import { Component, OnInit, ViewChild } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { CoreService, DialogResult, DialogService, DspxCardSetBaseFormComponent, SpinnerService } from 'dspx-core';
import { finalize, take } from 'rxjs';
import { API_ENDPOINTS , API_ENDPOINT_KEYS} from 'src/app/constants/api-endpoints.constants';
import { APPLICATION_TYPE, FILTER_QUESTION_CODES, NAV_TAB_NUMBERS, PAGE_NUMBERS, POP_UP_CODES, QUESTION_CODES, SAVE_RESULT_STATUS, SECTION_CODES } from 'src/app/constants/app-data.constants';
import { ROUTE_CONSTANTS } from 'src/app/constants/route.constants';
import { TEMPLATES } from 'src/app/constants/templates.constants';
import { Mapper, MapperBuilder, TRANSFORM } from 'src/app/helpers/mapper';
import { AppDataService } from 'src/app/services/app-data.service';
import { ErrorService } from 'src/app/services/error.service';
import { ResponseParserService } from 'src/app/services/response-parser.service';
import { BaseCardSetListComponent } from '../base-card-set-list-component/base-card-set-list.component';
import { ApplicationGridFilterRequest } from 'src/app/interfaces/application-grid-filter-request.interface';
// TODO: Pending requirement finalization. Copied and adapted concession application code for demo  
// and prototyping purposes. Actual implementation will be done once requirements are finalized.
@Component({
  selector: 'app-victorian-patient-transport-assistance-scheme-application-list',
  templateUrl: './victorian-patient-transport-assistance-scheme-application-list.component.html',
  styleUrl: './victorian-patient-transport-assistance-scheme-application-list.component.scss'
})
export class VictorianPatientTransportAssistanceSchemeApplicationListComponent extends BaseCardSetListComponent implements OnInit {
  getVictorianPatientTransportAssistanceSchemeApplications: boolean = true;
  @ViewChild(DspxCardSetBaseFormComponent)
  private set _baseForm(value: DspxCardSetBaseFormComponent) {
    this.baseForm = value
  }

  filterQuestionToFilterModelMapper: Mapper;
  activeDialog: string = '';
  selectedApplicationItems: any[] = [];

  constructor(
    protected router: Router,
    protected spinnerService: SpinnerService,
    protected dialogService: DialogService,
    protected responseParserService: ResponseParserService,
    protected appDataService: AppDataService,
    private coreService: CoreService,
    private errorService: ErrorService
  ) {
    super(
      router,
      spinnerService,
      dialogService,
      responseParserService,
      appDataService,
      TEMPLATES.vptasApplicationList,
      () => this.getListApiEndPoint(router),
      false);

    this.filterQuestionToFilterModelMapper =
      new MapperBuilder()
        .WithDefaultTargetFieldMapping(/Filter$/i, "") // When target field name is not specified, just use the source field's name, but drop "Filter" from the end
        .MapFrom(FILTER_QUESTION_CODES.victorianPatientTransportAssistanceSchemeApplicationListForm.applicationQuickSearchTerm)
        .MapFrom(FILTER_QUESTION_CODES.victorianPatientTransportAssistanceSchemeApplicationListForm.applicationReferenceNumberFilter)
        .MapFrom(FILTER_QUESTION_CODES.victorianPatientTransportAssistanceSchemeApplicationListForm.assignedToUserFilter)
        .MapFrom(FILTER_QUESTION_CODES.victorianPatientTransportAssistanceSchemeApplicationListForm.firstNameFilter)
        .MapFrom(FILTER_QUESTION_CODES.victorianPatientTransportAssistanceSchemeApplicationListForm.lastNameFilter)
        .MapFrom(FILTER_QUESTION_CODES.victorianPatientTransportAssistanceSchemeApplicationListForm.mobilePhoneFilter)
        .MapFrom(FILTER_QUESTION_CODES.victorianPatientTransportAssistanceSchemeApplicationListForm.applicationTypeFilter)
        .MapFrom(FILTER_QUESTION_CODES.victorianPatientTransportAssistanceSchemeApplicationListForm.applicationStatusFilter)
        .MapFrom(FILTER_QUESTION_CODES.victorianPatientTransportAssistanceSchemeApplicationListForm.applicationSubmittedOnFromFilter, TRANSFORM.STRING_TO_DATE)
        .MapFrom(FILTER_QUESTION_CODES.victorianPatientTransportAssistanceSchemeApplicationListForm.applicationSubmittedOnToFilter, TRANSFORM.STRING_TO_DATE)
        .MapFrom(FILTER_QUESTION_CODES.victorianPatientTransportAssistanceSchemeApplicationListForm.applicationYearFilter)
        .MapFrom(FILTER_QUESTION_CODES.victorianPatientTransportAssistanceSchemeApplicationListForm.datePaidFilter, TRANSFORM.STRING_TO_DATE)
        .MapFrom(FILTER_QUESTION_CODES.victorianPatientTransportAssistanceSchemeApplicationListForm.applicationSourceFilter)
        .MapFrom(FILTER_QUESTION_CODES.victorianPatientTransportAssistanceSchemeApplicationListForm.applicationPendingReasonFilter, TRANSFORM.IDENTITY)
        .MapFrom(FILTER_QUESTION_CODES.victorianPatientTransportAssistanceSchemeApplicationListForm.applicationFlaggedForReviewFilter)
        .MapFrom(FILTER_QUESTION_CODES.victorianPatientTransportAssistanceSchemeApplicationListForm.applicationPlaceholder, TRANSFORM.IDENTITY)
        .BuildMapper();
  }
  ngOnInit(): void {
    if (this.router.url.indexOf(ROUTE_CONSTANTS.vptasApplication.list.readyForApproval) >= 0) {
      this.formServiceEndpoint = API_ENDPOINT_KEYS.getVptasApprovedApplicationListConfig;
    }
    else if (this.router.url.indexOf(ROUTE_CONSTANTS.vptasApplication.list.pendingReview) >= 0) {
      this.formServiceEndpoint = API_ENDPOINT_KEYS.getVptasPendingApplicationListConfig;
    }
  }

  getListApiEndPoint(router: Router): string {    
    if (router.url.indexOf(ROUTE_CONSTANTS.vptasApplication.list.myApplications) >= 0) {
      return API_ENDPOINTS.dashboard.getVictorianPatientTransportAssistanceSchemeMyApplications;
    }
    else if (router.url.indexOf(ROUTE_CONSTANTS.vptasApplication.list.pendingReview) >= 0) {
      return API_ENDPOINTS.dashboard.getVictorianPatientTransportAssistanceSchemeApplicationsPendingReview;
    }
    else if (router.url.indexOf(ROUTE_CONSTANTS.vptasApplication.list.readyForApproval) >= 0) {
      return API_ENDPOINTS.dashboard.getVictorianPatientTransportAssistanceSchemeApplicationsReadyForApproval;
    }
    
    throw new Error(`Invalid router url ${router.url}`);
  }

  formLoad(event: any): void {
    if (history.state.applicationFilterRequest == null) {
      this.loadGridDataOnFormLoad();
    }
    else {
      this.loadGridDataOnFormLoad(history.state.applicationFilterRequest);
    }
  }

  filterData(event: any): void {
    const vptasApplicationFilterRequest = this.getApplicationFilterRequest();
    this.loadGridData(vptasApplicationFilterRequest);
  }  

  // actionButton_applicationPlaceholder_datagrid_colLink_referenceNumber_Clicked($event: any): void {
  //   const url = this.router.serializeUrl(this.router.createUrlTree(['/', ROUTE_CONSTANTS.concessionsApplication.prefix, ROUTE_CONSTANTS.concessionsApplicationDetail.prefix, $event.event.data.id]));
  //   window.open(url, '_blank');
  // }

  actionButton_applicationPlaceholder_datagrid_view_Clicked(event: any): void {    
    this.navigateToApplicationDetails(event);
  }

  actionButton_applicationPlaceholder_datagrid_edit_Clicked(event: any): void {
     this.navigateToApplication(event);
  }

  actionButton_applicationPlaceholder_datagrid_viewdetails_Clicked(event: any): void {
    this.navigateToApplication(event);
  }
  
actionButton_applicationPlaceholder_datagrid_custom_bulkAssign_Clicked(event: any): void {
    const eventData = event.event.data;    
    this.bulkAssign(eventData);
  }

   private bulkAssign(eventData) {
    this.selectedApplicationItems = eventData.selectedItems || [];
    
    if (!this.selectedApplicationItems || this.selectedApplicationItems.length === 0) {
      this.showApplicationSelectionAlert();
      return;
    }
    
    this.activeDialog = POP_UP_CODES.vptasApplicationDetails.bulkAssignApplicationUserPopup;
    this.dialogService.showDialog(this.activeDialog);
    }
    
  dialogButton_bulkAssignApplicationUserPopup_Clicked($event: any): void {
    
    if (!$event || !$event.assignedToUserIdPopup) {
      console.error("No user selected for assignment");
      return;
    }
    
    const ids = this.selectedApplicationItems.map(r => r.id);
    const request = {
      ids: ids,
      assignedToUserId: $event.assignedToUserIdPopup
    };
    
    this.spinnerService.showSpinner();
    this.appDataService.post(API_ENDPOINTS.victorianPatientTransportAssistanceSchemeApplication.bulkAssign, request)
      .pipe(
        take(1), 
        this.errorService.errorHandler(),
        finalize(() => this.spinnerService.hideSpinner())
      )
      .subscribe((response) => {
        this.onBulkAssignSuccess(response);
      });
  }
  
  onBulkAssignSuccess(response: any) {
    this.spinnerService.hideSpinner();
    if (response?.status === SAVE_RESULT_STATUS.success) {
      this.dialogService
        .showSimplePopup("Application(s) assigned successfully.", "Success!", "Ok")
        .subscribe(() => {
          const filterRequest = this.getApplicationFilterRequest();
          this.loadGridDataOnFormLoad(filterRequest);
        });
    }
  }
  
  actionButton_applicationPlaceholder_datagrid_custom_bulkApprove_Clicked(event: any): void {
    const eventData = event.event.data;    
    this.bulkApprove(eventData);
  }

  private bulkApprove(eventData) {
    this.dialogService
      .showConfirm(POP_UP_CODES.vptasApplicationList.bulkApproveConfirmation)
      .pipe(take(1))
      .subscribe((dialogResult: DialogResult) => {
        if (dialogResult === DialogResult.ACCEPTED) {
          const selectedIds = eventData.selectedItems;
          if (selectedIds.length <= 0) {
            this.showApplicationSelectionAlert();
          }
          else {
            const ids = selectedIds.map(r => r.id);
            this.appDataService.post(API_ENDPOINTS.victorianPatientTransportAssistanceSchemeApplication.bulkApprove, { ids: ids })
              .pipe(take(1), this.errorService.errorHandler(),
                finalize(() => this.spinnerService.hideSpinner))
              .subscribe((response) => {
                this.onBulkApproveSuccess(response);
              });
            }
              } 
            });
    }

  showApplicationSelectionAlert() {
    this.dialogService
      .showSimplePopup("Please select at least one application.", "Application Alert!", "Ok")
      .subscribe(
        result => {
        }
      );
  }
  showApplicationSelectionSuccess() {
    this.dialogService
      .showSimplePopup("Application(s) approved successfully.", "Success!", "Ok")
      .subscribe(
        result => {
        }
      );
  }

  onBulkApproveSuccess(response: any) {
    this.spinnerService.hideSpinner();
    if (response?.status === SAVE_RESULT_STATUS.success) {
      this.showApplicationSelectionSuccess();
      const filterRequest = this.getApplicationFilterRequest();
      this.loadGridDataOnFormLoad(filterRequest);
    }
  }

  actionButton_applicationPlaceholder_datagrid_delete_Clicked(event: any): void {
    const application = event.event.data;
    this.deleteApplication(application.id);
  }

  private deleteApplication(id) {
    this.dialogService
      .showConfirm(POP_UP_CODES.vptasApplicationList.deleteApplicationConfirmation)
      .pipe(take(1))
      .subscribe(data => {
        switch (data as DialogResult) {
          case DialogResult.ACCEPTED: {
            this.spinnerService.showSpinner();
            this.appDataService
            .postAndFetchData(`${API_ENDPOINTS.vptasApplication.delete}/${id}`)
              .pipe(take(1), this.errorService.errorHandler(),
                finalize(() => this.spinnerService.hideSpinner))
              .subscribe(response => {
                this.onDeleteApplicationSuccess(response);
              });
            break;
          }
          case DialogResult.REJECTED: {
            break;
          }
        }
      });
  }

  onDeleteApplicationSuccess(response: any) {
    this.spinnerService.hideSpinner();
    if (response?.status === SAVE_RESULT_STATUS.success) {
      this.loadGridData(this.loadGridDataOnFormLoad())
    }
  }  

  private navigateToApplication(event: any) {
    const navExtras = this.getNavigationExtras();
    const applicationId = event.event.data.id;
    const routePrefix = 
      event.event.data.applicationTypeId == APPLICATION_TYPE.victorianPatientTransportAssistanceScheme 
        ? ROUTE_CONSTANTS.victorianPatientTransportAssistanceSchemeApplication.prefix
        : ROUTE_CONSTANTS.vptasAdjustmentApplication.prefix;
    this.router.navigate(['/', routePrefix, applicationId], navExtras);
  }

  private navigateToApplicationDetails(event: any) {
    const navExtras = this.getNavigationExtras();
    const applicationId = event.event.data.id;
    if(event.event.data.applicationTypeId == APPLICATION_TYPE.victorianPatientTransportAssistanceScheme){
      this.router.navigate(['/', ROUTE_CONSTANTS.vptasApplication.prefix, ROUTE_CONSTANTS.vptasApplication.details.prefix, applicationId], navExtras);
    }
    else{
      this.router.navigate(['/', ROUTE_CONSTANTS.vptasAdjustmentApplication.prefix, applicationId], navExtras);
    }
  }

  private getApplicationFilterRequest(): ApplicationGridFilterRequest {
    let filterModel = this.getQuestionValue(
      this.model,
      NAV_TAB_NUMBERS.victorianPatientTransportAssistanceSchemeApplicationListForm.applications,
      PAGE_NUMBERS.victorianPatientTransportAssistanceSchemeApplicationListForm.applications,
      SECTION_CODES.victorianPatientTransportAssistanceSchemeApplicationListForm.applications,
      QUESTION_CODES.victorianPatientTransportAssistanceSchemeApplicationListForm.applicationListFilter
    );
    let mappedFilters = this.filterQuestionToFilterModelMapper.Map(filterModel);   

    // Set dashboard type based on current route
    if (this.router.url.indexOf(ROUTE_CONSTANTS.vptasApplication.list.myApplications) >= 0) {
      mappedFilters.dashboardType = 0; // All
    } else if (this.router.url.indexOf(ROUTE_CONSTANTS.vptasApplication.list.pendingReview) >= 0) {
      mappedFilters.dashboardType = 2; // PendingReview
    } else if (this.router.url.indexOf(ROUTE_CONSTANTS.vptasApplication.list.readyForApproval) >= 0) {
      mappedFilters.dashboardType = 3; // ReadyForApproval
    } else {
      mappedFilters.dashboardType = 0; // All
    }

    return mappedFilters;
  }

  private getNavigationExtras(): NavigationExtras {
    const filterRequest = this.getApplicationFilterRequest();

    return {
      state: {
        applicationFilterRequest: filterRequest
      }
    };
  }
}
